import React from 'react';
import { PureTable } from 'src/pages/OfferPage/TableSvgOrganizer/PureTable';
import { RoomHeader } from 'src/pages/OfferPage/TableSvgOrganizer/RoomHeader';
import { CustomRowButton } from 'src/pages/OfferPage/TableSvgOrganizer/CustomRowButton';
import { RoomMap } from './RoomMap';
import { QuotePlaceholderMap } from 'src/pages/OfferPage/QuotePlaceholderMap/QuotePlaceholderMap';
import { ProjectQuoteUserProperties } from "src/model/api/project.model";
import { GetAllManufacturerDiscountForProjectResponse } from "src/model/api/manufacturer-discount.model";
import { Product } from "src/model/product.model";
import { ManufacturerRecommendationResponse } from "src/model/api/manufacturer-recommendation";

export const TableRoom = (
    {
      projectId,
      floorname,
      detailsEnabled,
      tablesEnabled,
      tableDLStarted,
      floorMapsEnabled,
      roomMapsEnabled,
      gotsvgs,
      tableRoom,
      currency,
      dispatchDownloadStates,
      currentRowInEditing,
      setCurrentRowInEditing,
      measurementSystem,
      quoteUserProperties,
      allManufacturerDiscountForProject,
      manufacturerRecommendationForProject,
      customItemsForRecommendation,
    }: {
      projectId: number;
      floorname: any;
      detailsEnabled: boolean;
      tablesEnabled: boolean;
      tableDLStarted: boolean;
      floorMapsEnabled: boolean;
      roomMapsEnabled: boolean;
      gotsvgs: boolean;
      tableRoom: any;
      currency: string;
      dispatchDownloadStates: any;
      currentRowInEditing: any;
      setCurrentRowInEditing: any;
      measurementSystem: string;
      quoteUserProperties: ProjectQuoteUserProperties;
      allManufacturerDiscountForProject: GetAllManufacturerDiscountForProjectResponse;
      manufacturerRecommendationForProject: ManufacturerRecommendationResponse;
      customItemsForRecommendation: Product[];
    }
) => {

  const [customRowButtonPressed, setCustomRowButtonPressed] =
    React.useState(null);

  return (
    <div className="pdf-room break-before">
      <div className="pdf-room-image break-inside-avoid map-center-align">
        {(roomMapsEnabled &&
          (!gotsvgs || (gotsvgs && !!tableRoom.roomSvgObj))) ||
        (tablesEnabled && tableRoom.hasRows) ? (
          <RoomHeader
              tableRoom={tableRoom}
              floorname={floorname}
              measurementSystem={measurementSystem}
          />
        ) : null}

        {gotsvgs ? (
          <RoomMap enabled={roomMapsEnabled} roomMapObj={tableRoom.roomSvgObj} />
        ) : roomMapsEnabled ? (
          <QuotePlaceholderMap height="500" cls="quote-roomSVG" />
        ) : null}
      </div>
      {tableRoom.tables.map((table: any) =>
        table.entitytype !== "roomtable_count" ? (
          <React.Fragment key={`${table.entitytype}_${table.id}`}>
            <PureTable
              projectId={projectId}
              table={table}
              detailsEnabled={detailsEnabled}
              tablesEnabled={tablesEnabled}
              dlStarted={tableDLStarted}
              guessed={table.guessed}
              customRowButtonPressed={customRowButtonPressed}
              setCustomRowButtonPressed={setCustomRowButtonPressed}
              currency={currency}
              dispatchDownloadStates={dispatchDownloadStates}
              icons={tableRoom.tables[0].rows}
              currentRowInEditing={currentRowInEditing}
              setCurrentRowInEditing={setCurrentRowInEditing}
              labourCost={null}
              measurementSystem={measurementSystem}
              quoteUserProperties={quoteUserProperties}
              allManufacturerDiscountForProject={allManufacturerDiscountForProject}
              manufacturerRecommendationForProject={manufacturerRecommendationForProject}
              customItemsForRecommendation={customItemsForRecommendation}
            />
            {tablesEnabled && table.entitytype !== "roomtable_count" ? (
              <CustomRowButton
                table={table}
                customRowButtonPressed={customRowButtonPressed}
                setCustomRowButtonPressed={setCustomRowButtonPressed}
                setCurrentRowInEditing={setCurrentRowInEditing}
              />
            ) : null}
          </React.Fragment>
        ) : null
      )}
    </div>
  );
};
